import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  buttonSize: 'md'
} satisfies RecursivePartial<DialogConfig['notifyMe']>
